import React, { Component } from 'react'
import Context from './Context'
import { TELEGRAM_THEME_VARS, mergeClasses } from './telegramTheme'
import './vendor/telegram-ui.css'
import './TelegramChip.css'

const MODE_CLASS = {
  elevated: 'tgui-b8b077d7e3491b30',
  mono: 'tgui-ccc3e4a302799418',
  outline: 'tgui-fdfccf8f92c11530'
}

class TelegramChip extends Component {
  static contextType = Context

  render () {
    const theme = this.context && this.context.theme === 'dark' ? 'dark' : 'light'

    const {
      mode = 'elevated',
      before,
      after,
      description,
      bare = false,
      disabled = false,
      children,
      onClick,
    } = this.props

    const wrapperClassName = mergeClasses([
      'TelegramChipDemo',
      theme === 'dark' ? 'TelegramChipDemo--dark' : 'TelegramChipDemo--light'
    ])

    const chipClassName = mergeClasses([
      'tgui-6372c64c79ad2959',
      MODE_CLASS[mode] || MODE_CLASS.elevated,
      'TelegramChip',
      disabled ? 'TelegramChip--disabled' : null,
    ])

    const hintClassName = mergeClasses([
      'TelegramChipHint',
      theme === 'dark' ? 'TelegramChipHint--dark' : null,
    ])

    const chipNode = (
      <div
        role='button'
        aria-disabled={ disabled }
        className={ chipClassName }
        onClick={ disabled ? undefined : onClick }
      >
        { before &&
          <span className='tgui-0d7ce20ebc0fc7aa'>{ before }</span>
        }

        <span className='tgui-9c7ff8cd23a6ea9a TelegramChipText'>
          { children || 'Chip' }
        </span>

        { after &&
          <span className='tgui-67f596882eb2b6ab'>{ after }</span>
        }
      </div>
    )

    if (bare) {
      return chipNode
    }

    return (
      <div
        className={ wrapperClassName }
        style={{ ...TELEGRAM_THEME_VARS[theme] }}
      >
        { chipNode }

        { description &&
          <div className={ hintClassName }>{ description }</div>
        }
      </div>
    )
  }
}

export default TelegramChip
